import { render } from "./returnForm.vue?vue&type=template&id=370de9ae&scoped=true"
import script from "./returnForm.vue?vue&type=script&lang=js"
export * from "./returnForm.vue?vue&type=script&lang=js"

import "./returnForm.vue?vue&type=style&index=0&id=370de9ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370de9ae"]])

export default __exports__